module.exports = __webpack_public_path__ + "img/y1.6a73ecce.png";